import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">VikaVikaTattoo</h3>
          <p className="footer-description">
            Профессиональные тату и перманентный макияж от лучшего мастера
          </p>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-subtitle">Контакты</h4>
          <div className="footer-contacts">
            <a href="tel:+79999999999" className="footer-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
              </svg>
              +7 (999) 999-99-99
            </a>
            <a href="mailto:vikavika@tattoo.ru" className="footer-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              vikavika@tattoo.ru
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-subtitle">Социальные сети</h4>
          <div className="social-links">
            <a href="https://instagram.com" className="social-link" aria-label="Instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://vk.com" className="social-link" aria-label="VK">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15.07 2H8.93C3.33 2 2 3.33 2 8.93v6.14C2 20.67 3.33 22 8.93 22h6.14c5.6 0 6.93-1.33 6.93-6.93V8.93C22 3.33 20.67 2 15.07 2zm3.77 14.39c-.13.33-.78.61-1.61.61-1.15 0-3.49-.73-5.23-3.27-.27-.41-.79-.41-1.06 0-1.74 2.54-4.08 3.27-5.23 3.27-.83 0-1.48-.28-1.61-.61-.13-.32.14-.79.79-1.29 1.83-1.41 3.03-3.44 3.03-3.44s-.27-.27-.27-.65c0-1.28 1.03-2.32 2.32-2.32.65 0 1.03.27 1.03.27s.27-1.41 2.06-1.41 2.06 1.41 2.06 1.41s.38-.27 1.03-.27c1.28 0 2.32 1.03 2.32 2.32 0 .38-.27.65-.27.65s1.2 2.03 3.03 3.44c.65.5.92.97.79 1.29z"/>
              </svg>
            </a>
            <a href="https://t.me" className="social-link" aria-label="Telegram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.78 5.42-.92 6.8-.06.62-.34.83-.8.83-.67 0-1.18-.46-1.83-.9-1.02-.71-1.59-1.15-2.58-1.84-.45-.3-.81-.46-.92-.76-.09-.27.02-.42.25-.62.85-.75 1.77-1.72 1.77-1.72s.23-.23.1-.46c-.06-.1-.27-.15-.48-.09-.33.09-.56.18-.9.3-.76.27-1.37.44-1.94.42-.41-.01-1.2-.23-1.78-.42-.27-.09-.48-.14-.66-.14-.3 0-.48.14-.48.43 0 .27.38.57 1.06.9 1.47.72 2.51 1.39 3.85 2.24.75.48 1.35.72 1.95.72.45 0 .9-.15 1.35-.45.57-.39.9-.87 1.2-1.38.9-1.32 1.59-2.94 1.95-4.41.12-.54.27-1.14.27-1.44 0-.33-.24-.48-.66-.48-.36 0-.78.09-1.59.42z"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-subtitle">Часы работы</h4>
          <div className="working-hours">
            <p>Пн-Пт: 10:00 - 20:00</p>
            <p>Сб-Вс: 11:00 - 18:00</p>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-divider"></div>
        <div className="footer-copyright">
          <p>&copy; {currentYear} VikaVikaTattoo. Все права защищены.</p>
          <p className="footer-made-with">
            Сделано с <span className="heart">❤</span> для искусства
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;